import React from "react";
import { Typography } from "@mui/material";
import ThumbUpIcon from '@mui/icons-material/ThumbUp';
import ThumbDownIcon from '@mui/icons-material/ThumbDown';

interface VotingTypeActionProps {
  action_value?: any;
  result?: any;
}

export default function VotingTypeAction({ action_value, result }: VotingTypeActionProps) {
  const validActions = Array.isArray(action_value)
    ? action_value.filter((action: any) => action)
    : [];

  return (
    <>
      {validActions.map((action: any, index: number) => (
        <div key={index} style={{ display: 'flex', marginBottom: '10px' }}>
          <Typography sx={{ fontWeight: 'bold', marginRight: '20px' }}>
            {action?.config_details?.value?.title || action?.title || `Vote ${index + 1}`}:
          </Typography>
            <Typography variant="body1" sx={{ display: 'flex', alignItems: 'center', marginBottom: '8px' }}>
              {action.support ? (
                <ThumbUpIcon style={{ color: 'green', marginLeft: '8px' }} />
              ) : (
                <ThumbDownIcon style={{ color: 'red', marginLeft: '8px' }} />
              )}
            </Typography>
        </div>
      ))}
    </>
  );
}